import { gql } from '@apollo/client';

export const JOB_APPLICATION_FIELDS = gql`
  fragment JobApplicationFields on JobApplication {
    jobApplicationId
    jobApplicationStatus
    jobId
  }
`;
